import { useDeviceInfo } from 'hooks/useDeviceInfo';
import { MobileVehicleCardPortrait } from './MobileVehicleCardPortrait';
import { MobileVehicleCardProps } from './types';
import { MobileVehicleCardLandscape } from './MobileVehicleCardLandscape';

export const MobileVehicleCard = ({ vehicle }: MobileVehicleCardProps) => {
  const { orientation } = useDeviceInfo();
  if (orientation === 'landscape') {
    return <MobileVehicleCardLandscape vehicle={vehicle} />;
  }
  return <MobileVehicleCardPortrait vehicle={vehicle} />;
};
